import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError, isAxiosError } from 'axios';

import {
  NewsletterSubscribeApiResponse,
  NewsletterSubscribeApiError,
  NewsletterInfoApiResponse,
} from './newsletterSubscribe.types';
import { NEWSLETTER_SUBSCRIPTION_ERR_MSG } from './newsletterSubscribe.constants';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

export const useNewsletterSubscribeMutation = () => {
  return useMutation<
    NewsletterSubscribeApiResponse,
    AxiosError<NewsletterSubscribeApiError>,
    string
  >({
    mutationFn: async (email: string) => {
      try {
        const { data } = await clientAxios.post('/newsletterSubscribeApi/', {
          email,
        });

        return data;
      } catch (error) {
        if (isAxiosError(error) && error.response) {
          const {
            error: { data, status },
          } = error.response.data as NewsletterSubscribeApiError;

          switch (status) {
            case 400:
              throw new Error(NEWSLETTER_SUBSCRIPTION_ERR_MSG[data.detail]);
            default:
              throw new Error(NEWSLETTER_SUBSCRIPTION_ERR_MSG.DEFAULT);
          }
        }
      }
    },
  });
};

export const useNewsletterInfoApi = () => {
  return useQuery({
    queryKey: ['newsletterInfoApi'],
    queryFn: async () => {
      const { data } = await clientAxios.get<
        ApiResponse<NewsletterInfoApiResponse>
      >('/newsletterInfoApi/');

      return data.data.subscription_count;
    },
  });
};
